import { SendKanhaEmails } from '../send-kanha-emails/SendKanhaEmails';

export const SendKanhaInviteEmail = () => {
	return (
		<>
			<SendKanhaEmails templateKey="EXAM_MODULE_KANHA_BATCH_INVITE_EMAIL_TEMPLATE" />
		</>
	);
};
